import { authorizedInstance } from "../config/axios"

export const getReportRoutingLogs = async (params = {}) => {
  if (params?.createdAt) {
    const [startDate, endDate] = params.createdAt.split(",")
    params.startDate = startDate
    params.endDate = endDate
    delete params.createdAt
  }
  const query = new URLSearchParams(params)

  const response = await authorizedInstance.get(`/report-routing-logs?${query}`)

  return response.data
}

export const getDistinctPatientIssuers = async () => {
  const response = await authorizedInstance.get(
    "/report-routing-logs/patient-issuers"
  )
  return response.data
}

export const getReportRoutingLogById = async (logId) => {
  const response = await authorizedInstance.get(`/report-routing-logs/${logId}`)
  return response.data
}
